import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TranslationModule } from 'src/app/modules/translation.module';
import { HeaderMainComponent } from './header-main.component';
import { UiHeaderSubpageComponent } from '../ui/ui-header-subpage/ui-header-subpage.component';
import { MenuHeaderComponent } from '../menu-header/menu-header.component';
import { faSquare } from '@fortawesome/free-solid-svg-icons/faSquare';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@lenovo/material/tooltip';


@NgModule({
	declarations: [
		HeaderMainComponent,
		UiHeaderSubpageComponent,
		MenuHeaderComponent
	],
	exports: [
		HeaderMainComponent,
		UiHeaderSubpageComponent,
		MenuHeaderComponent
	],
	imports: [
		CommonModule,
		TranslationModule.forChild(),
		RouterModule,
		FontAwesomeModule,
		MatTooltipModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
	]
})
export class HeaderMainModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faSquare);
	}
}
